<script>
  import { onMount } from "svelte";
  import { link } from 'svelte-spa-router';
  import { getBaseApiUrl } from "../../api/base";
  
  const name_url = getBaseApiUrl();
  const redirect_url = REDIRECT_URL;
  
  let pictureDefaultMax = "/static/errors_2.png";
  let pictureDefaultMin = "/static/errors-tablet 1.png";
  let screenWidth = window.innerWidth;;
  
  
  let refresh_token_id = undefined
  onMount ( async ()=>{
    try{
      let tok = JSON.parse(atob(localStorage.refresh_token.split('.')[1]));
      refresh_token_id = tok.user_id
    }
    catch{
      refresh_token_id = undefined
    }
  })
  function changeToken(){
    let redirect_query = `&redirect=${redirect_url}`
    window.location.replace(`${name_url}jwt-auth/redirect-refresh-token/to-content/?`+redirect_query)
  }
  </script>
  
  <div class="main">
    <div class="main_information">
  
      {#if screenWidth > 768}
      <div class="main_picture">
        <img src={pictureDefaultMax} alt/>
      </div>
      {:else}
      <div class="main_picture">
        <img src={pictureDefaultMin} alt/>
      </div>
      {/if}
      <div class="main_text">
        <span class="text_oops text-bold">Упс!</span>
        <span class="text_line text-grey">
          Что-то пошло не так. Возникла проблема с авторизацией. Попробуй еще раз и нажми на кнопку "Перезагрузить"
        </span>
        <span class="text_line text-grey">
          Если проблема сохраняется - без паники!) Обратись за помощью на почту <a href="mailto:info@fizikl.org">info@fizikl.org</a>
        </span>
          <span class="text_id">Твой ID: {refresh_token_id}</span>
        <div class="main_button">
          <button class="button_reload text-bold" on:click="{()=> changeToken()}">Перезагрузить</button>
          <a class="button_exit text-bold" href='/logout/' use:link>Выйти</a> 
        </div>
        
      </div> 
  
    </div>
  </div>
  
  
  
<style>
  .main{
    display: flex;
    justify-content: center;
    margin-top: 100px;
    padding:0 50px 0 50px;
  }
  .main_information{
    max-width: 1070px;
    width:100%;
    display: flex;
    justify-content: start;
    box-shadow: 0px 2px 8px rgba(16, 16, 122, 0.16);
    border-radius: 10px;
  }
  .main_text{
    display: flex;
    flex-direction:column;
    padding: 30px 30px 30px 30px;
  }
  
  .main_picture{
    display: inline-block;
    height: 100%;
    width: 500px;
  }
  
  img{
    width: 100%;
    height: 100%;
    border-radius: 10px 0 0 10px;
  }
  
  .text_oops{
    font-size: 30px;
    line-height: 39px;
    color: #30333D;
    padding-bottom: 16px;
  }
  .text_line{
    font-size: 18px;
    line-height: 26px;
  }
  .text_id{
    font-size: 16px;
    line-height: 23px;
    color: rgba(90, 95, 109, 0.6);
    padding: 16px 0 16px 0;
  }
  a{
    text-decoration: none;
  }
  .main_button{
    display: flex;
    flex-direction: row;
    justify-content: start;
    align-items: start;
  }
   .button_reload, .button_exit{
    padding: 14px 18px;
    font-size: 14px;
    line-height: 20px;
    border-radius: 44px;
    cursor: pointer;
    margin-right: 15px;
  }
  .button_reload{
    background: #2B50ED;
    color: #FFFFFF;
    border: 2px solid #2B50ED;
  }
  .button_exit{
    background: #FFFFFF;
    color: #2B50ED;
    border: 2px solid #2B50ED;
  }
  
  @media (max-width: 768px){
    .main{
      padding:0 24px 0 24px;
    }
    .main_information{
      display: flex;
      flex-direction:column;
    }
    .main_picture{
      display: inline-block;
      height: 100%;
      width: 100%;
    }
    img{
      border-radius: 10px 10px 0 0;
    }
  }
  @media (max-width: 500px){
    .button_reload, .button_exit{
      padding: 10px 12px;
      margin-right: 5px;
    }
  }
</style>
